// extracted by mini-css-extract-plugin
export default {"bookmarkChip":"Pg_4_2_bookmarkChip__pSF2P"};